function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from 'react';
import _ from 'lodash';
import { Divider, Input, Form, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useRequest } from '@umijs/hooks';
import client from '../../../feathers';
var {
  Option
} = Select;

function getCategories() {
  return _getCategories.apply(this, arguments);
}

function _getCategories() {
  _getCategories = _asyncToGenerator(function* () {
    var query = {
      $limit: -1,
      $select: ['category'],
      $sort: {
        name: 1
      }
    };
    var params = {
      query
    };
    var categories = yield client.service('scenarios').find(params);
    return _.reduce(categories, (result, scenario, index) => {
      var {
        category
      } = scenario;

      if (!result.includes(category)) {
        result.push(category);
      }

      return result;
    }, []);
  });
  return _getCategories.apply(this, arguments);
}

var index = 0;

function Category() {
  var [children, setChildren] = useState([]);
  var [name, setName] = useState('');
  var {
    data,
    error,
    loading
  } = useRequest(() => getCategories(), {
    onSuccess: (categories, params) => {
      var options = categories.map((category, index) => /*#__PURE__*/React.createElement(Option, {
        key: index,
        value: category
      }, category));
      setChildren(options);
    }
  });

  function onSearch(value) {
    console.log("selected ".concat(value));
  }

  function addItem() {
    var childName = name || "New item ".concat(index++);
    var newChild = /*#__PURE__*/React.createElement(Option, {
      key: childName
    }, childName);
    setChildren([...children, newChild]);
    setName('');
  }

  function onNameChange(e) {
    setName(e.target.value);
  }

  return /*#__PURE__*/React.createElement(Form.Item, {
    name: "category",
    label: "Category"
  }, /*#__PURE__*/React.createElement(Select, {
    placeholder: "Select category...",
    showSearch: true,
    onSearch: onSearch,
    dropdownRender: menu => /*#__PURE__*/React.createElement("div", null, menu, /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: '4px 0'
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexWrap: 'nowrap',
        padding: 8
      }
    }, /*#__PURE__*/React.createElement(Input, {
      style: {
        flex: 'auto'
      },
      value: name,
      onChange: onNameChange
    }), /*#__PURE__*/React.createElement("a", {
      style: {
        flex: 'none',
        padding: '8px',
        display: 'block',
        cursor: 'pointer'
      },
      onClick: addItem
    }, /*#__PURE__*/React.createElement(PlusOutlined, null), " Add item")))
  }, children));
}

export default Category;